import { z } from 'zod';

export const FILTER_CARDS_STATES = ['active', 'cancelled'] as const;

export type FilterCardsStatesKeys = (typeof FILTER_CARDS_STATES)[number];

export const clientCardsFilterFormSchema = z.object({
	cardState: z.enum(FILTER_CARDS_STATES).prefault('active'),
});

export type ClientCardsFilterForm = z.infer<typeof clientCardsFilterFormSchema>;
